<div class="accordion-editor" [class.no-edit-mode]="!isEditMode">
    <div *ngIf="!item.isEditing" #categoryItem>
        <ig-accordion #accordion *ngIf="item.subCategories.length" [icon]="isEditMode?'edit':''"
            [icon2]="isEditMode?'link':''" [title]="item.title" (onIconClick)="enterEditMode(item)"
            (onIcon2Click)="showURL()" (onFold)="toggle(false)" (onExpand)="toggle(true)" (click)="expandCategory()"
            [class.is-expanded]="isExpanded">
            <div class="sub-cate-wrapper">

                <div *ngIf="!isEditMode" item class="sub-all-category" (click)="setCategories(item)"
                    [ngStyle]="{'color':isSelected?'#41abf3':'rgba(0, 0, 0, 0.87)','fontWeight':isSelected?'bold':'normal'}">
                    All</div>

                <div *ngFor="let sub of item.subCategories;let i=index" #subaccordion draggable [dragEnabled]="true"
                    [dragScope]="item.id" droppable [dropScope]="item.id" [dragData]="sub"
                    (onDragEnter)="dragEnter($event)" (onDrop)="onItemDrop($event, i, item)">
                    <ig-accordion-editor [item]="sub" [maxLevels]="maxLevels" [isEditMode]="isEditMode"
                        (onCategoryClick)="setCategories($event)"
                        (onToggle)="syncCategoryListAreaHeightWithEditorAreaHeight()"
                        (onRemoved)="syncCategoryListAreaHeightWithEditorAreaHeight()"
                        (onSubCategoryAdded)="syncCategoryListAreaHeightWithEditorAreaHeight()" [title]="sub.title"
                        [parent]="item">
                    </ig-accordion-editor>
                </div>

            </div>
            <div item *ngIf="isEditMode" class="add-sub-category" (click)="addSubCategory()">+ sub-category</div>
        </ig-accordion>
        <div item *ngIf="!item.subCategories.length" class="category-level flex space-between ellipsis"
            (click)="setCategories(item)">
            <span class="pointer">
                <mat-icon *ngIf="isEditMode" (click)="enterEditMode(item)">edit</mat-icon>
                <span
                    [ngStyle]="{'color':isSelected?'#41abf3':'rgba(0, 0, 0, 0.87)','fontWeight':isSelected?'bold':'normal'}">{{item.title}}</span>
                <mat-icon *ngIf="isEditMode" (click)="showURL()" matTooltip="get link">link</mat-icon>
                <mat-icon *ngIf="isEditMode" class="red-text" (click)="removeSubCategory()"
                    matTooltip="delete this category">delete</mat-icon>
            </span>
            <span *ngIf="isEditMode&&canAddSub()" class="add-sub-category pointer" (click)="addSubCategory()">+
                sub-category</span>
        </div>
    </div>

    <div class="flex category-edit-box" *ngIf="item.isEditing">
        <ig-field label="Edit category name" [formControl]="form.get('categoryName')" icon="edit"
            [(ngModel)]="tempTitle">
        </ig-field>
        <ig-button size="md" [isAsync]="false" (trigger)="updateCategoryTitle()">save</ig-button>
        <ig-button size="md" color="cancel" (trigger)="cancelUpdateTitle()">cancel</ig-button>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/accordion.editor/accordion.editor.component.html